module.exports = __webpack_public_path__ + "static/media/yahooMailLogo.1cafa8a5.svg";